import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useApi } from '../../api/api-context';
export const useUpdateBudgetApi = (options) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const [isPending, setIsPending] = useState(false);
    const budgetsKey = ['budgets'];
    // API call
    const updateBudgetApi = async (data) => {
        await api.put(`/budget`, data);
    };
    const mutation = useMutation({
        mutationFn: updateBudgetApi,
        onMutate: async (request) => {
            setIsPending(true);
            const budgetKey = ['budget', request.id];
            // Cancel any outgoing refetches
            await queryClient.cancelQueries({ queryKey: budgetKey });
            await queryClient.cancelQueries({ queryKey: budgetsKey });
            // Snapshot the previous values
            const previousBudget = queryClient.getQueryData(budgetKey);
            const previousBudgets = queryClient.getQueryData(budgetsKey);
            // Only update the single budget if it exists in the cache
            if (previousBudget) {
                queryClient.setQueryData(budgetKey, {
                    ...previousBudget,
                    ...request,
                });
            }
            // Optimistically update the budgets list
            queryClient.setQueryData(budgetsKey, (oldBudgets = []) => {
                return oldBudgets.map((budget) => budget.id === request.id
                    ? {
                        ...budget,
                        ...request,
                    }
                    : budget);
            });
            if (options?.onSuccess) {
                options.onSuccess();
            }
            return { budget: previousBudget, budgets: previousBudgets };
        },
        onError: (_error, variables, context) => {
            // Rollback on error using the budgetId from the variables
            const budgetKey = ['budget', variables.id];
            if (context?.budget !== undefined) {
                queryClient.setQueryData(budgetKey, context.budget);
            }
            if (context?.budgets !== undefined) {
                queryClient.setQueryData(budgetsKey, context.budgets);
            }
        },
        onSettled: (_data, _error, variables) => {
            setIsPending(false);
            // Invalidate and refetch using the budgetId from the variables
            const budgetKey = ['budget', variables.id];
            queryClient.invalidateQueries({ queryKey: budgetKey });
            queryClient.invalidateQueries({ queryKey: budgetsKey });
        },
    });
    return {
        mutate: mutation.mutate,
        isPending: isPending || mutation.isPending,
        isError: mutation.isError,
        error: mutation.error,
    };
};
